import { InjectionToken } from '@angular/core';
import { environment } from '../environments/environment';
import { Environment } from '../environments/environment.model';

/** Injectable view of the build-time environment, so specs can substitute one. */
export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT', {
  providedIn: 'root',
  factory: () => environment,
});
